export default {
    LOAD_NOTES: 'LOAD_NOTES',
    VFLIP_FRETBOARD: 'VFLIP_FRETBOARD',
    HFLIP_FRETBOARD: 'HFLIP_FRETBOARD',
    CHANGE_TUNING: 'CHANGE_TUNING',
    CHANGE_INSTRUMENT: 'CHANGE_INSTRUMENT',
    MIDI_NOTE_ON: 'MIDI_NOTE_ON',
    MIDI_NOTE_OFF: 'MIDI_NOTE_OFF',
};
